// Avatar utility for comments and profile displays
// Uses local memoji avatars based on user gender

export const MALE_AVATARS = ['/avatars/Male-memoji-5.svg', '/avatars/Male-memoji-6.svg', '/avatars/Male-memoji-7.svg'];
export const FEMALE_AVATARS = ['/avatars/Female-memoji-1.svg', '/avatars/Female-memoji-2.svg', '/avatars/Female-memoji-3.svg', '/avatars/Female-memoji-4.svg'];
export const ALL_AVATARS = [...MALE_AVATARS, ...FEMALE_AVATARS];

/**
 * Convert a relative avatar path to a full URL
 * @param {string} relativePath - Relative avatar path (e.g., '/avatars/memoji-1.svg')
 * @returns {string} Full URL
 */
function toFullUrl(relativePath) {
  // In browser environment, use window.location.origin
  if (typeof window !== 'undefined' && window.location?.origin) {
    return `${window.location.origin}${relativePath}`;
  }
  // Fallback for SSR or non-browser environments
  return relativePath;
}

/**
 * Get a consistent avatar for comments based on user gender
 * @param {string} gender - User's gender ('male', 'female', or undefined)
 * @param {string} seed - Optional seed for consistent avatar selection (e.g., user name)
 * @returns {string} Full avatar URL
 */
export function getCommentAvatar(gender, seed = '') {
  // Create a simple hash from the seed for consistent selection
  const hashCode = seed.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);

  let avatarPath;

  if (gender?.toLowerCase() === 'male') {
    avatarPath = MALE_AVATARS[hashCode % MALE_AVATARS.length];
  } else if (gender?.toLowerCase() === 'female') {
    avatarPath = FEMALE_AVATARS[hashCode % FEMALE_AVATARS.length];
  } else {
    // If gender not defined, pick from all avatars
    const allAvatars = [...MALE_AVATARS, ...FEMALE_AVATARS];
    avatarPath = allAvatars[hashCode % allAvatars.length];
  }

  return toFullUrl(avatarPath);
}

export default getCommentAvatar;
